import { useQuery } from '@tanstack/react-query';

import { searchEvents } from './credit-service';

const duplicateEventSearchOptions = (orgId, search, enabled) => ({
  queryKey: ['organization', orgId, 'duplicate-event-search', search],
  queryFn: () => searchEvents(search, orgId),
  enabled: enabled && search !== '',
  keepPreviousData: true,
  select: results => results.map(({ id, name, shortcode: code }) => ({ id, code, name })),
});

export const useDuplicateEventSearch = (orgId, search, enabled = true) =>
  useQuery(duplicateEventSearchOptions(orgId, search, enabled));
